import { PromoRole, PromoTag } from '~/services/PromoService';

interface getPromoTagArraysProps {
  promoTags: Array<PromoTag>;
  selectedDepartment: string | null;
  selectedCategory: string | null;
  /**
   * When null, all tags will allowed, when set, only tags where the user has the required role will be allowed
   */
  usersPromoRoles: Array<PromoRole> | null;
}

const promoTagSort = (a, b) => (a === 'N/A' ? 1 : b === 'N/A' ? -1 : a.localeCompare(b));
/**
 *
 * @param promoTags from svc-promo getPromoMeta endpoint
 * @returns Arrays for department, category, and subcategory tags selection options
 */
export function getPromoTagArrays({
  promoTags,
  selectedDepartment,
  selectedCategory,
  usersPromoRoles,
}: getPromoTagArraysProps): App.PromoTagArrays {
  const departmentTags: Array<string> = Array.from(new Set(promoTags.map((pt) => pt.departmentTag) ?? [])).sort(
    promoTagSort,
  );
  const categoryTags: Array<string> = Array.from(
    new Set(
      promoTags
        .filter((pt) => pt.departmentTag === selectedDepartment && !!pt.categoryTag)
        .map((pt) => pt.categoryTag) ?? [],
    ),
  ).sort(promoTagSort);

  // If we've only got one category, select it automatically so we can show sub-category tag options
  const autoSelectedCategory = categoryTags.length == 1 ? categoryTags[0] : null;

  const subCategoryTags: Array<string> = Array.from(
    new Set(
      promoTags
        .filter(
          (pt) =>
            pt.departmentTag === selectedDepartment &&
            (pt.categoryTag === selectedCategory || pt.categoryTag === autoSelectedCategory) &&
            !!pt.subCategoryTag,
        )
        .map((pt) => pt.subCategoryTag) ?? [],
    ),
  ).sort(promoTagSort);

  const allowedCategoryTags = promoTags.filter((tag) =>
    usersPromoRoles?.some((role) => (!tag.roleIdRequired || role.roleId === tag.roleIdRequired) && role.isActive),
  );

  const allowedSubCategoryTags = promoTags.filter(
    (tag) =>
      usersPromoRoles == null ||
      usersPromoRoles?.some((role) => (!tag.roleIdRequired || role.roleId === tag.roleIdRequired) && role.isActive),
  );

  return {
    promoTags,
    departmentTags,
    categoryTags,
    subCategoryTags,
    allowedCategoryTags: allowedCategoryTags,
    allowedSubCategoryTags: allowedSubCategoryTags,
  };
}
